import repository from '@/repositories/repository'

export default baseUrl => {
    baseUrl = `${baseUrl}/autenticacao`

    return {
        login: params => {
            return repository.post(`${baseUrl}/login`, params)
        },
        logout: () => {
            return repository.post(`${baseUrl}/logout`)
        },
        trocarSenha: (id, params) => {
            return repository.put(`${baseUrl}/trocar-senha/${id}`, params)
        },
        recuperarSenha : params => {
            return repository.post(`${baseUrl}/recuperar-senha`, params)
        },
        refresh: async params => {
            return repository.post(`${baseUrl}/refresh`, params)
        },
    }
}